import React, { Suspense } from 'react';
import { Text, Flexbox, Avatar, IconButton, Skeleton } from '@sonika-se/ui-kit/components';
import { createUseStyles } from 'react-jss';
import { useIntl } from 'react-intl';
import { formatTimeSpan } from '@sonika-se/ui-kit/utils/time';
import { useQueryLoader } from 'react-relay/hooks';
import { faAngleRight, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import ScheduleTemplateInformationResourceScheduleTimes, { scheduleTemplateInformationResourceScheduleTimesQuery, } from './ScheduleTemplateInformationResourceScheduleTimes';
const useStyles = createUseStyles((theme) => ({
    tableRow: {
        height: theme.helpers.pxToRem(40),
    },
    bold: {
        fontWeight: 'bold',
    },
    tableHeader: {
        color: theme.colors.foreground.tertiary,
    },
    tableCell: {
        width: '5rem',
        textAlign: 'center',
        '&:first-child': {
            textAlign: 'left',
        },
        '&:last-child': {
            textAlign: 'right',
            paddingRight: '.5rem',
        },
    },
    tableRowSmall: {
        paddingLeft: '2rem',
        height: theme.helpers.pxToRem(24),
    },
}));
export const ScheduleTemplateInformationResourceTableRow = (props) => {
    const { date, entity, selectedPeriodId, templateId } = props;
    const intl = useIntl();
    const classes = useStyles();
    const name = (entity === null || entity === void 0 ? void 0 : entity.displayName) ||
        intl.formatMessage({
            defaultMessage: 'Vakant',
            id: 'general.misc.schedule_shift.vacant.singular',
        });
    const [scheduleTemplateInformationResourceScheduleTimesQueryRef, loadScheduleTemplateInformationResourceScheduleTimesQuery, disposeScheduleTemplateInformationResourceScheduleTimesQuery,] = useQueryLoader(scheduleTemplateInformationResourceScheduleTimesQuery);
    return (<div key={entity.id}>
      <Flexbox justify="space" className={classes.tableRow} align="center">
        <Flexbox gap="xsmall" align="center">
          <IconButton icon={scheduleTemplateInformationResourceScheduleTimesQueryRef ? faAngleUp : faAngleRight} appearance="text" color="default" size="small" onClick={() => {
            if (!scheduleTemplateInformationResourceScheduleTimesQueryRef) {
                loadScheduleTemplateInformationResourceScheduleTimesQuery({
                    entitiesFilter: {
                        assignedResources: [entity.id],
                    },
                    model: {
                        endDate: date.endDate,
                        startDate: date.startDate,
                        startPeriodId: selectedPeriodId,
                        id: templateId,
                        dryRun: true,
                    },
                }, {
                    fetchPolicy: 'network-only',
                });
            }
            else {
                disposeScheduleTemplateInformationResourceScheduleTimesQuery();
            }
        }}/>
          <Avatar size="xsmall" text={name} color={(entity === null || entity === void 0 ? void 0 : entity.color) || '#fd544f'}/>
          <span>{name}</span>
        </Flexbox>
        <Text className={classes.tableCell}>{formatTimeSpan(entity.assignedDurationWithoutUnpaidBreaks)}</Text>
      </Flexbox>
      <Suspense fallback={<div style={{ paddingBottom: '0.5rem', paddingLeft: '3rem', paddingRight: '0.5rem' }}>
            <Skeleton type="table"/>
          </div>}>
        {scheduleTemplateInformationResourceScheduleTimesQueryRef && (<div style={{ paddingBottom: '0.5rem', paddingLeft: '3rem', paddingRight: '0.5rem' }}>
            <ScheduleTemplateInformationResourceScheduleTimes preloadedQuery={scheduleTemplateInformationResourceScheduleTimesQueryRef}/>
          </div>)}
      </Suspense>
    </div>);
};
